import { createSelectorDeep } from 'reselects/misc';
import { isFtb, isPrio, isRecovering } from 'utils/shipper';

const getShipperOrdersObject = (state) => state.shipperOrders.plainData;

const getShipperOrdersLoadStatus = (state) => ({
  loading: state.shipperOrders.loading,
  ready: !state.shipperOrders.loading,
});

export const computeShipper = (shipper) => {
  return {
    ...shipper,
    isNew: isFtb(shipper),
    isPriority: isPrio(shipper),
    isRecovering: isRecovering(shipper),
  };
};

const mapShipperOrdersForComputedProperties = ({ shipper, ...shipperOrder } = {}) => {
  return {
    ...shipperOrder,
    shipper: computeShipper(shipper),
  };
};

const getShipperOrder = createSelectorDeep(
  getShipperOrdersObject,
  (_, itemId) => itemId,
  (shipperOrdersObject, itemId) => {
    return mapShipperOrdersForComputedProperties(shipperOrdersObject.get(itemId));
  }
);

const getGroupedByDateTotals = (state) => state.shipperOrders.groupedTotals;

const getGroupedByDate = createSelectorDeep(
  (state) => state.shipperOrders.groupedData,
  (groupedByDate) => groupedByDate
);

const getListOfIds = createSelectorDeep(getGroupedByDate, (grouped) =>
  Object.keys(grouped)
    .reduce((acc, date) => [...acc, ...grouped[date]], [])
    .reduce((acc, id) => [...acc, id], [])
);

const getNextPageLink = (state) => state.shipperOrders.nextLink;
const getIsMounted = (state) => state.shipperOrders.mounted;
const getLastUpdate = (state) => state.shipperOrders.lastUpdate;
const getIsVisible = (state) => state.shipperOrders.visible;
const getLastPage = (state) => state.shipperOrders.lastPage;
const getIsNextPageLoading = (state) => state.shipperOrders.loadingNextPage;

export {
  getShipperOrdersObject,
  getShipperOrder,
  mapShipperOrdersForComputedProperties,
  getGroupedByDate,
  getGroupedByDateTotals,
  getListOfIds,
  getShipperOrdersLoadStatus,
  getNextPageLink,
  getIsMounted,
  getLastUpdate,
  getIsVisible,
  getLastPage,
  getIsNextPageLoading,
};
